{
  "global.siteDescription": "عرّف بنفسك بوضوح خلال 30 ثانية ليسهل على الآخرين معرفتك.",
  "global.languageSwitch": "تبديل اللغة",
  "global.languageCurrent": "اللغة الحالية: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "إغلاق",
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.manage": "إدارة",
  "common.login": "تسجيل الدخول",
  "common.logout": "تسجيل الخروج",
  "common.loggingOut": "جارٍ تسجيل الخروج",
  "common.logoutRetry": "أعد محاولة تسجيل الخروج",
  "common.preview": "معاينة",
  "common.email": "Email",
  "common.inviteCode": "رمز الدعوة",
  "common.loading": "جارٍ التحميل",
  "editor.publish.processing": "لا تزال المعالجة جارية",
  "common.localDraft": "مسودة محلية",
  "common.publicBeta": "النسخة التجريبية العامة",
  "common.serviceStatus": "حالة الخدمة",
  "common.optional": "اختياري",
  "common.page": "صفحة",
  "common.reason": "سبب",
  "common.description": "تفاصيل",
  "common.submit": "إرسال",
  "nav.login": "تسجيل الدخول",
  "nav.draftFirst": "ابدأ المسودة",
  "home.action.create": "إنشاء نبذتي",
  "home.action.continue": "متابعة الكتابة",
  "home.action.manage": "إدارة النبذة",
  "home.action.agent": "Agent يكتب عنك",
  "home.meta.title": "30s.to — 30 ثانية ليتعرّفوا عليك.",
  "home.meta.description": "حين تمضي بمفردك، يصبح تعريف الآخرين بنفسك أكثر أهمية. 30 ثانية ليتعرّفوا عليك. من أنت، وما تعمل عليه، وما أنجزته، وما يمكنك تقديمه من موارد. ساعد الآخرين على اكتشاف ما يثير اهتمامهم والتواصل معك.",
  "home.title": "30 ثانية\nليتعرّفوا عليك.",
  "home.freeNote": "أنشئ وانشر وشارك. مجانًا دائمًا.",
  "home.kicker": "حين تمضي بمفردك، يصبح تعريف الآخرين بنفسك أكثر أهمية.",
  "home.value.copy": "من أنت، وما تعمل عليه، وما أنجزته، وما يمكنك تقديمه من موارد. ساعد الآخرين على اكتشاف ما يثير اهتمامهم والتواصل معك.",
  "home.features.label": "المميزات",
  "home.features.time.tab": "اقرأ في 30 ثانية",
  "home.why.copy": "اكتب الأهم فقط. كلما طالت النبذة، قلّ من يقرأها حتى النهاية. 30 ثانية هي المدة المناسبة.",
  "home.principle.expression.title": "عبّر عن نفسك",
  "home.principle.expression.copy": "رتّب خبراتك وأعمالك وأفكارك ومواردك بطريقتك. شارك ما تريد أن يعرفه الآخرون عنك.",
  "home.principle.link.title": "رابطك الخاص على 30s.to",
  "home.principle.link.copy": "30s.to/@you قصير وسهل التذكّر، ومعناه مباشر: التعرّف عليك في 30 ثانية.",
  "home.principle.theme.title": "قوالب متنوعة تعبّر عنك",
  "home.principle.theme.copy": "بسيط أو كلاسيكي أو جريء بألوان زاهية. اختر سمة تشبهك ليظهر أسلوبك من النظرة الأولى.",
  "home.footer.tagline": "قل أقل ليظهر ما يهم.",
  "home.footer.navigation": "التنقل في التذييل",
  "home.demo.linkNotice": "هذا هو الرابط التجريبي. قم بإنشاء مقدمة مدتها 30 ثانية لإضافة المقدمة الخاصة بك.",
  "home.demo.profile.name": "مايا تشين",
  "home.demo.profile.identity": "مصمم منتجات مستقل يحول المشكلات المعقدة إلى منتجات بسيطة",
  "home.demo.profile.tag.product": "تصميم المنتج",
  "home.demo.profile.tag.indie": "منتجات إيندي",
  "home.demo.profile.tag.ai": "أدوات AI",
  "home.demo.profile.body": "## الآن\nأبني Briefly ليقضي المصممون المستقلون وقتًا أقل في نقل الملاحظات وأكثر في فهم الناس. قبل التصميم أرافق مستخدمًا في تنفيذ المهمة الفعلية.\n\n## مسيرتي\n2020–2023: تصميم المحرر وتجربة المستخدم الجديد في فريق برمجيات تعاونية. عملت مع المهندسين لتقسيم العمليات المعقدة إلى خطوات ممكنة.\n\nمنذ 2024 أعمل بشكل مستقل في أبحاث المستخدمين وتصميم التفاعل للفرق الناشئة، وأطوّر منتجاتي الصغيرة.\n\n## المشاريع\n- [Relay](https://example.com/projects/relay): صممت سجل القرارات هذا ليجمع النتائج والأسباب والمسؤولين، فيفهم المنضمون الجدد السياق.\n- [Briefly](https://example.com/projects/briefly): قيد تجربة محدودة، ينظم ملاحظات المقابلات في موضوعات قابلة للتتبع ويحفظ الأقوال الأصلية للتحقق من الاستنتاجات.\n\n## ما أستطيع مشاركته\nلديك ملاحظات ولا تعرف ما تعدّله أولًا؟ يمكنني المساعدة في تحديد المشكلة وبناء نموذج قابل للاختبار. أشارك أيضًا أدلة المقابلات وقوالب التدوين مع الفرق التي تبدأ أبحاث المستخدمين.\n\n## لنتحدث\nأود مناقشة المقابلات الأولى والمفاضلات والعمل المستقل مع المهتمين بالمنتجات الصغيرة المتقنة. أزور متاجر الحي في العطلة؛ أحيانًا تعلّمني قائمة أسعار مكتوبة باليد أكثر من شرح المنتج.",
  "home.demo.profile.link.website": "عمل",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "احجز محادثة",
  "handleStart.kicker": "الرابط العام",
  "handleStart.title": "اختر رابطك على 30s.to",
  "handleStart.copy": "اختر رابطًا يسهل تذكره أولًا، ثم اكتب تعريفك في 30 ثانية. سنحتفظ بأي مسودة موجودة.",
  "handleStart.label": "رابطك",
  "handleStart.help.empty": "4-24 حرفًا صغيرًا. يؤدي هذا إلى حفظ مسودة فقط؛ يتم تأكيد التوفر عند النشر.",
  "handleStart.help.ok": "الشكل يبدو جيدا. يتم التحقق من التوفر مرة أخرى عند النشر.",
  "handleStart.submit": "مواصلة الكتابة",
  "handleAvailability.checking": "جارٍ التحقق من هذا الرابط…",
  "handleAvailability.available": "متوفر الآن. يصبح لك بعد النشر الناجح.",
  "handleAvailability.owned": "أنت تملك هذا العنوان بالفعل.",
  "handleAvailability.assigned": "تم تخصيص هذا العنوان لك ويصبح ساري المفعول بعد النشر.",
  "handleAvailability.failed": "تعذر التحقق من هذا الرابط. حاول مرة أخرى.",
  "handleAvailability.rateLimited": "عدد كبير جدًا من عمليات التحقق. حاول مرة أخرى بعد {minutes} دقيقة.",
  "handleAvailability.retry": "تحقق مرة أخرى",
  "handleAvailability.suggestions": "يمكنك أيضًا تجربة",
  "handleAvailability.cooldown": "لا يزال الرابط العام ضمن فترة الانتظار البالغة 30 يومًا. يمكنك تغييره بعد {date} أو استعادة الرابط المنشور حاليًا.",
  "editor.shell.loading": "جارٍ تحميل إنشاء التدفق",
  "editor.shell.workspace": "مساحة عمل مقدمة مدتها 30 ثانية",
  "editor.shell.canvas": "سطح كتابة مقدمة مدته 30 ثانية",
  "editor.command.aria": "شريط أوامر المحرر",
  "editor.command.publish": "نشر",
  "editor.command.publishUpdate": "نشر التغييرات",
  "editor.command.publishSettings": "نشر الإعدادات",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "تم النشر",
  "editor.publish.successAfterLogin": "تم تسجيل الدخول والنشر",
  "editor.publish.publishing": "جارٍ النشر…",
  "editor.publish.publishingDetail": "نُعِدّ صفحتك العامة الآن. يُرجى الانتظار قليلًا.",
  "editor.publish.successDetail": "تم تحديث صفحتك العامة وأصبحت جاهزة للعرض.",
  "editor.publish.viewPublic": "عرض الصفحة العامة",
  "editor.publish.cacheFailed": "ولكن فشلت كتابة ذاكرة التخزين المؤقت للصفحة العامة.",
  "editor.command.login": "تسجيل الدخول",
  "editor.handle.editTitle": "تحرير العنوان العام",
  "editor.handle.claimAfterPublish": "لك بعد النشر",
  "editor.handle.claimAfterPublishTitle": "يصبح هذا العنوان ملكك بعد النشر",
  "editor.status.signedIn": "تم تسجيل الدخول",
  "editor.status.account": "الحساب: {email}",
  "editor.status.localTitle": "مشروع محلي",
  "editor.status.localCopy": "يتم حفظ هذه المسودة على هذا الجهاز فقط. قم بتسجيل الدخول لمزامنته مع السحابة.",
  "editor.status.location": "حفظ الموقع",
  "editor.status.state": "حفظ الحالة",
  "editor.status.emailLogin": "تسجيل الدخول Email",
  "editor.autosave.savingShort": "جارٍ الحفظ",
  "editor.autosave.savedCloudShort": "تم الحفظ في السحابة",
  "editor.autosave.savedLocalShort": "تم الحفظ محليًا",
  "editor.autosave.failedShort": "فشل الحفظ",
  "editor.autosave.signedInShort": "تم تسجيل الدخول",
  "editor.autosave.cloud": "سحاب",
  "editor.autosave.retry": "يحتاج إلى إعادة المحاولة",
  "editor.autosave.device": "هذا الجهاز",
  "editor.autosave.saving": "الحفظ التلقائي...",
  "editor.autosave.savedLocal": "تم الحفظ تلقائيًا محليًا",
  "editor.autosave.savedCloud": "تم الحفظ تلقائيًا في السحابة",
  "editor.autosave.authExpired": "انتهت صلاحية الجلسة. تم الحفظ محليًا.",
  "editor.autosave.cloudFailed": "فشل الحفظ السحابي. تم الحفظ محليًا.",
  "editor.autosave.cloudUnavailable": "الحفظ السحابي غير متصل بعد. تم الحفظ محليًا.",
  "editor.autosave.failed": "فشل الحفظ التلقائي. انسخ المحتوى الخاص بك وأعد المحاولة.",
  "editor.autosave.enabled": "الحفظ التلقائي قيد التشغيل",
  "identity.namePlaceholder": "اسمك",
  "identity.nameAria": "الاسم أو اللقب",
  "identity.identityPlaceholder": "هوية سطر واحد",
  "identity.identityAria": "هوية سطر واحد",
  "identity.tagsAria": "العلامات",
  "identity.addTag": "إضافة علامة",
  "identity.removeTag": "إزالة العلامة {tag}",
  "body.emptyInstruction": "اكتب أهم ما ينبغي أن يعرفه شخص يلتقي بك للمرة الأولى.\nاكتب أقل كي يبرز المهم. 30 ثانية، وهذا يكفي تمامًا.",
  "body.templatesLabel": "يمكنك أيضًا البدء من قالب",
  "body.templatesAria": "قوالب الهوية للنص",
  "body.templateExampleLabel": "ملف تجريبي",
  "body.viewTemplateExample": "عرض المثال",
  "links.sectionAria": "روابط",
  "links.documentTitle": "روابط",
  "links.documentCopy": "الملفات الشخصية الاجتماعية والحجز وتفاصيل الاتصال",
  "links.documentEmptyCopy": "أضف ملفًا شخصيًا اجتماعيًا أو صفحة حجز أو طريقة اتصال. يمكنك تغييرها في أي وقت.",
  "links.add": "إضافة رابط",
  "links.addType": "إضافة {label}",
  "links.edit": "تحرير {label}",
  "links.addedAria": "الروابط المضافة",
  "links.closePanel": "إغلاق محرر الارتباط",
  "links.editTitle": "تعديل الرابط",
  "links.addTitle": "إضافة رابط",
  "links.chooseTypeAgain": "اختر نوع الرابط مرة أخرى",
  "links.calendarProvider": "مزود الحجز",
  "links.displayName": "اسم العرض",
  "links.duplicate": "تمت إضافة {label} بالفعل.",
  "links.alreadyAdded": "تمت إضافة {label} بالفعل",
  "links.bookingAlreadyAdded": "تمت إضافة الحجز بالفعل",
  "links.remove": "يمسح",
  "links.category.social": "اجتماعي",
  "links.category.booking": "الحجز",
  "links.category.work": "الأعمال / المواقع الإلكترونية",
  "links.category.content": "محتوى",
  "links.category.contact": "اتصال",
  "links.category.other": "آخر",
  "links.type.x": "X",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "شياو هونغشو",
  "links.type.wechat": "حساب وي شات الرسمي",
  "links.type.email": "Email",
  "links.type.calendar": "الحجز",
  "links.type.website": "موقع إلكتروني",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "جيك",
  "links.type.other": "آخر",
  "links.input.x": "مقبض X",
  "links.input.github": "مقبض GitHub",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "مقبض Instagram",
  "links.input.youtube": "مقبض YouTube",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "ملف تعريف Xiaohongshu URL",
  "links.input.wechat": "معرف حساب WeChat الرسمي",
  "links.input.email": "Email",
  "links.input.calendar": "مسار الحجز",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "مقبض TikTok",
  "links.input.threads": "مقبض Threads",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "مقبض Dribbble",
  "links.input.jike": "الملف الشخصي لجيك URL",
  "links.input.other": "رابط URL",
  "links.input.calendar.cal": "مسار Cal.com",
  "links.input.calendar.calendly": "مسار كاليندلي",
  "links.input.calendar.google": "صفحة الحجز Google Calendar",
  "links.input.calendar.microsoft": "رابط Microsoft Bookings",
  "links.input.calendar.hubspot": "رابط HubSpot Meetings",
  "links.input.calendar.savvycal": "مسار SavvyCal",
  "links.input.calendar.tidycal": "مسار TidyCal",
  "links.input.calendar.zcal": "مسار زكال",
  "links.hint.handle": "أدخل اسم المستخدم فقط، وليس الرابط كاملًا.",
  "links.hint.uid": "أدخل فقط UID، وليس ملف التعريف URL.",
  "links.hint.slug": "أدخل المسار فقط، وليس URL بالكامل.",
  "links.hint.email": "يؤدي هذا إلى إنشاء رابط mailto.",
  "links.hint.text": "النقر على الصفحة العامة ينسخ هذه القيمة.",
  "links.hint.url": "أدخل رابط https:// صالحًا لهذا النظام الأساسي.",
  "links.hint.calendarSlug": "أدخل اسم المستخدم أو مسار الحجز فقط، وليس URL الكامل.",
  "links.hint.calendarUrl": "أدخل صفحة الحجز الكاملة URL لهذه المنصة.",
  "rich.toolbarAria": "شريط أدوات تنسيق النص",
  "rich.heading": "عنوان القسم",
  "rich.paragraph": "فقرة",
  "rich.bold": "عريض",
  "rich.boldFallback": "نص غامق",
  "rich.italic": "مائل",
  "rich.italicFallback": "نص مائل",
  "rich.code": "رمز مضمن",
  "rich.comment": "تبديل التعليق",
  "rich.ul": "قائمة نقطية",
  "rich.ol": "قائمة مرقمة",
  "rich.link": "وصلة",
  "rich.linkPrompt": "أدخل رابط https:// أو mailto:",
  "rich.linkInvalid": "تدعم الروابط https:// أو mailto فقط:",
  "rich.linkFallback": "نص الرابط",
  "rich.aria": "مقدمة مدتها 30 ثانية",
  "rich.more": "المزيد من التنسيق",
  "rich.quote": "اقتباس",
  "rich.strikethrough": "يتوسطه خط",
  "rich.strikethroughFallback": "نص يتوسطه خط",
  "rich.codeBlock": "كتلة تعليمات برمجية",
  "rich.codeBlockFallback": "تعليمات برمجية",
  "rich.taskList": "قائمة مهام",
  "rich.table": "جدول",
  "rich.tableSkeleton": "| العنصر | الوصف |\n| --- | --- |\n| العنصر الأول | الوصف الأول |\n| العنصر الثاني | الوصف الثاني |",
  "rich.indent": "زيادة المسافة البادئة",
  "rich.outdent": "تقليل المسافة البادئة",
  "rich.placeholder": "اكتب مقدمة Markdown يمكن قراءتها في 30 ثانية...",
  "feedback.aria": "كتابة ردود الفعل",
  "feedback.timeTitle": "الوقت المقدر للقراءة",
  "feedback.preview": "معاينة",
  "feedback.previewMenu": "فتح قائمة المعاينة",
  "feedback.openAcceptancePreview": "فتح معاينة القبول",
  "feedback.acceptancePreviewCopy": "عرض نتيجة الصفحة العامة على هذا الجهاز",
  "feedback.noIssues": "لا توجد قضايا حظر",
  "feedback.prePublish": "الشيكات قبل النشر",
  "feedback.ready": "لا حاصرات",
  "feedback.itemCount": "عناصر {count}",
  "feedback.valid": "يمر المحتوى بنشر الشيكات.",
  "issue.action.displayName": "أضف اسما",
  "issue.action.oneLineIdentity": "أضف هوية",
  "issue.action.tags": "إضافة العلامات",
  "issue.action.body": "العودة إلى النص",
  "issue.action.handle": "اختر العنوان",
  "issue.action.links": "إدارة الروابط",
  "issue.action.view": "منظر",
  "issue.short.displayName": "الاسم مفقود",
  "issue.short.oneLineIdentity": "هوية مفقودة",
  "issue.short.tags": "العلامات المفقودة",
  "issue.short.handle": "عنوان مفقود",
  "issue.short.readingTime": "أكثر من 60 ثانية",
  "issue.short.readingTimeLong": "أكثر من 30 ثانية",
  "issue.short.readingTimeShort": "محتوى قليل جدًا",
  "issue.short.bodyPlaceholder": "محتوى تجريبي في النص",
  "issue.short.bodyFormat": "تنسيق النص",
  "issue.short.links": "مشكلة الارتباط",
  "issue.short.linksEmpty": "يمكن إضافة الروابط",
  "issue.short.pending": "يحتاج إلى عمل",
  "issue.summary.more": "عناصر {count} لإصلاحها",
  "publish.title.create": "تأكيد النشر",
  "publish.title.update": "تأكيد التغييرات",
  "publish.action.create": "انشر على 30s.to",
  "publish.action.update": "نشر التغييرات",
  "publish.closeAria": "إغلاق تأكيد النشر",
  "publish.address": "العنوان العام",
  "publish.unpublishedChanges": "تغييرات غير منشورة",
  "publish.handleChanged": "سيتغير عنوانك من @{oldHandle} إلى @{newHandle}. سيعيد العنوان السابق التوجيه لمدة 30 يومًا. بعد 180 يومًا من التغيير، قد يُمنح لشخص آخر وقد تعرض الروابط القديمة ملفه.",
  "publish.readingTime": "وقت القراءة",
  "publish.status": "حالة",
  "publish.ready": "مستعد",
  "publish.todo": "عناصر {count} للتحسين",
  "publish.visibility": "طريقة النشر",
  "publish.visibility.indexed": "السماح بالفهرسة في محركات البحث",
  "publish.visibility.unlisted": "متاح عبر الرابط",
  "publish.visibility.indexedNote": "يمكن لأي شخص عرض الصفحة، وقد تظهر في نتائج البحث.",
  "publish.visibility.unlistedNote": "يمكن لأي شخص لديه الرابط عرض الصفحة؛ ولن نرسلها إلى محركات البحث.",
  "publish.visibility.publicNote": "كلا الخيارين عام، ويمكن إعادة توجيه الرابط. احتفظ بها كمسودة إذا كنت تريد أن تراها وحدك.",
  "publish.publicContent": "عند النشر يصبح الاسم والنبذة والوسوم والنص والروابط عامة. لا تظهر تعليقات الكاتب، لكن يجب ألا تحتوي على أسرار.",
  "publish.noop": "الصفحة العامة محدثة بالفعل. قم بتغيير المحتوى أو الرؤية قبل النشر مرة أخرى.",
  "publish.valid": "يمر المحتوى بنشر الشيكات.",
  "handleEdit.title": "تحرير العنوان العام",
  "handleEdit.label": "عنوان 30s.to",
  "handleEdit.help.changed": "يغيّر الحفظ المسودة فقط. بعد النشر، يعيد العنوان السابق التوجيه لمدة 30 يومًا، وقد يُمنح لشخص آخر بعد 180 يومًا.",
  "handleEdit.help.saved": "تم الحفظ في المسودة. يتم التحقق من التوفر مرة أخرى عند النشر.",
  "handleEdit.note": "العنوان العام الحالي لا يزال 30s.to/@{handle}. يصبح العنوان الجديد ساري المفعول بعد النشر.",
  "handleEdit.save": "حفظ للمسودة",
  "conflict.title": "اختر نسخة المسودة",
  "conflict.copy": "يحتوي كل من هذا الجهاز والسحابة على محتوى غير منشور. يصبح اختيارك هو الإصدار التالي الذي سيتم تعديله.",
  "conflict.useLocal": "استخدم المسودة المحلية",
  "conflict.useLocalCopy": "احتفظ بمحتوى الصفحة الحالية وقم بمزامنته مع السحابة.",
  "conflict.useCloud": "استخدم المسودة السحابية",
  "conflict.untitled": "بدون عنوان",
  "conflict.cloudVersion": "النسخة المحفوظة في السحابة",
  "conflict.modifiedAt": "آخر تعديل · {time}",
  "conflict.time.justNow": "الآن",
  "conflict.time.minutesAgo": "قبل {count} دقيقة",
  "conflict.time.hoursAgo": "قبل {count} ساعة",
  "conflict.time.daysAgo": "قبل {count} يوم",
  "authModal.title": "قم بتسجيل الدخول إلى 30s.to",
  "authModal.copy": "بعد تسجيل الدخول، تتم مزامنة المسودات مع السحابة ويصبح النشر أكثر موثوقية.",
  "login.page.eyebrow": "حساب",
  "login.page.title": "قم بتسجيل الدخول إلى 30s.to",
  "login.page.copy": "مزامنة المسودات ونشر الصفحات العامة وإدارة الدعوات.",
  "login.invalidEmail": "أدخل بريدًا إلكترونيًا صالحًا.",
  "login.sendFailed": "لا يمكن إرسال الرمز.",
  "login.devCodeReady": "تم إنشاء رمز التنمية المحلية.",
  "login.codeSent": "تم إرسال الرمز. تحقق من بريدك الإلكتروني.",
  "login.networkSendFailed": "لا يمكن إرسال الرمز. تحقق من اتصالك.",
  "login.invalidCode": "أدخل الرمز المكون من 6 أرقام.",
  "login.codeInvalid": "الرمز خاطئ أو منتهي الصلاحية.",
  "login.failed": "فشل تسجيل الدخول. حاول مرة أخرى لاحقًا.",
  "login.sendBusy": "إرسال...",
  "login.resendCode": "إعادة إرسال الرمز",
  "login.sendCode": "إرسال الرمز",
  "login.localCode": "رمز التنمية المحلية: {code}",
  "login.code": "شفرة",
  "login.codePlaceholder": "6 أرقام",
  "login.inviteHelp": "يتطلب الإصدار التجريبي العام رمز دعوة. التحقق ينشط حسابك.",
  "login.verifyBusy": "جارٍ التحقق...",
  "login.verifyInvite": "التحقق من الدعوة وتسجيل الدخول",
  "login.verify": "تسجيل الدخول والمتابعة",
  "login.footnote": "تسجيل الدخول بدون كلمة مرور. يتم تنشيط المستخدمين الجدد بدعوة بعد التحقق من البريد الإلكتروني.",
  "login.google": "تواصل مع جوجل",
  "login.github": "تواصل مع GitHub",
  "login.emailDivider": "أو استخدم البريد الإلكتروني",
  "login.oauthFailed": "تسجيل الدخول الاجتماعي لم ينته. حاول مرة أخرى أو استخدم تسجيل الدخول عبر البريد الإلكتروني.",
  "login.linkTitle": "التحقق من البريد الإلكتروني للحساب",
  "login.linkPageCopy": "يستخدم حساب 30s.to هذا البريد الإلكتروني بالفعل. ولا نقوم بربطه إلا بعد التحقق؛ لا يتم دمج الحسابات تلقائيًا أبدًا.",
  "login.linkCopy": "سوف نرسل رمزًا إلى {email}. لا يمكن تغيير البريد الإلكتروني هنا.",
  "login.linkVerify": "التحقق والربط",
  "login.linkRequired": "تم العثور على حساب موجود. قم بتأكيد بريده الإلكتروني للمتابعة.",
  "login.activateTitle": "تفعيل 30s.to",
  "login.activatePageCopy": "تم التحقق من هويتك الاجتماعية. لا يتم إنشاء حساب دائم حتى تنجح الدعوة.",
  "login.activateCopy": "يتطلب الإصدار التجريبي العام دعوة. ولا يتم استردادها إلا عند نجاح إنشاء الحساب.",
  "login.activationOpenCopy": "التسجيل مفتوح الآن. تابع لتفعيل حسابك.",
  "login.activationClosedCopy": "تم إيقاف تفعيل الحسابات الجديدة مؤقتًا. لا يزال بإمكان الحسابات الحالية تسجيل الدخول.",
  "login.activate": "التنشيط والمتابعة",
  "login.inviteRequired": "تم التحقق من Email. استخدم دعوة للتنشيط.",
  "login.useEmailInstead": "استخدم تسجيل الدخول عبر البريد الإلكتروني بدلاً من ذلك",
  "preview.emptyEyebrow": "معاينة",
  "preview.emptyTitle": "لا توجد مقدمة متاحة للمعاينة.",
  "preview.backToEdit": "العودة إلى التحرير",
  "preview.edit": "يحرر",
  "preview.localNoteAria": "ملاحظة المعاينة المحلية",
  "preview.localNote": "القبول المحلي",
  "preview.localTitle": "معاينة المسودة على هذا الجهاز",
  "preview.themePicker": "مبدل الموضوع",
  "preview.themeGroup": "اختر الموضوع",
  "preview.themeFree": "قاعدة",
  "preview.themePro": "Pro",
  "preview.mobileAria": "معاينة الصفحة العامة على الجوال",
  "preview.close": "إغلاق المعاينة",
  "preview.editorTitle": "معاينة",
  "preview.publicTitle": "معاينة الصفحة العامة",
  "preview.shareCardButton": "عرض بطاقة الموضوع",
  "preview.shareCardDialogTitle": "معاينة بطاقة الموضوع",
  "preview.shareCardTitle": "بطاقة موضوع {theme}",
  "preview.shareCardLogin": "قم بتسجيل الدخول لتقديم المعاينة الحقيقية",
  "preview.shareCardLoading": "جارٍ عرض بطاقة الموضوع...",
  "preview.shareCardError": "معاينة البطاقة غير متاحة مؤقتًا",
  "preview.shareCardNote": "تستخدم بطاقة الموضوع نفس اللغة المرئية المستخدمة في الصفحة العامة. البطاقات العالمية متوفرة في Dashboard.",
  "public.copySuccess": "منسوخ {label}",
  "public.copyFailed": "فشل النسخ. يرجى النسخ يدويا.",
  "public.createMine": "إنشاء المقدمة الخاصة بي",
  "public.report": "الإبلاغ عن هذه الصفحة",
  "public.ownerAria": "مدخل الإدارة الشخصية",
  "public.owner.manage": "يدير",
  "public.owner.edit": "يحرر",
  "public.status.unavailable": "غير متاح",
  "public.status.notFound": "404",
  "public.status.moderated": "هذه المقدمة التي تبلغ مدتها 30 ثانية غير متوفرة.",
  "public.status.frozen": "هذا العنوان العام غير متوفر.",
  "public.status.unpublished": "لم يتم نشر هذه المقدمة التي تبلغ مدتها 30 ثانية بعد.",
  "theme.footer": "مصنوعة من 30s.to",
  "theme.fallback.name": "اسمك",
  "theme.fallback.nameUpper": "اسمك",
  "theme.fallback.nameNoir": "اسم",
  "theme.fallback.nameIndex": "جون دو",
  "theme.fallback.identity": "ماذا تفعل؟",
  "theme.fallback.identityUpper": "هويتك ورسالتك في خط واحد",
  "theme.fallback.identityIndex": "مجهول",
  "theme.fallback.identityNoir": "هوية",
  "theme.fallback.terminalName": "ضيف",
  "theme.fallback.terminalIntro": "لا يوجد مقدمة قصيرة حتى الآن",
  "theme.terminal.commandLabel": "الأمر الطرفي",
  "theme.terminal.commandSubmit": "تشغيل الأمر",
  "theme.terminal.outputLabel": "مخرجات المحطة التفاعلية",
  "theme.connect": "يتصل",
  "theme.markdown.tableRegion": "جدول المحتوى، قابل للتمرير أفقيًا",
  "theme.markdown.task": "مهمة",
  "theme.tags": "العلامات",
  "theme.verified": "تم التحقق منه",
  "theme.name": "اسم",
  "theme.identityLabel": "هوية",
  "theme.keywords": "الكلمات الرئيسية",
  "theme.scroll": "قم بالتمرير",
  "theme.pixel.previous": "الشاشة السابقة",
  "theme.pixel.next": "الشاشة التالية",
  "theme.pixel.screen": "شاشة {current} من {total}",
  "theme.arcade.stage": "المرحلة {current} / {total}",
  "theme.noise.reseed": "إعادة زرع الضوضاء",
  "theme.readingTime": "قراءة {seconds} ث",
  "theme.readingUnit": "ث قراءة",
  "theme.letter.greeting": "مرحبًا،",
  "theme.letter.signoff": "مع خالص التحية،",
  "theme.letter.postscript": "يمكنك العثور عليّ هنا",
  "theme.letter.written": "كُتبت في {date}",
  "dashboard.loginTitle": "قم بتسجيل الدخول لإدارة المقدمة الخاصة بك.",
  "dashboard.loginAction": "تسجيل الدخول والإدارة",
  "dashboard.bannedTitle": "هذا الحساب غير متوفر حاليا.",
  "dashboard.bannedCopy": "إذا كنت تعتقد أن هذا خطأ، فاتصل بنا من خلال إدخال التقرير والاستئناف.",
  "connections.kicker": "حساب",
  "connections.title": "طرق تسجيل الدخول",
  "connections.settingsKicker": "الإعدادات",
  "connections.settingsTitle": "الحساب والاتصالات",
  "connections.settingsCopy": "إدارة هويات تسجيل الدخول وصلاحيات Agents التابعة لجهات خارجية.",
  "connections.backToDashboard": "العودة إلى لوحة التحكم",
  "connections.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "connections.alwaysAvailable": "متاح دائمًا",
  "connections.connect": "يتصل",
  "connections.disconnect": "قم بإزالة رابط 30s.to",
  "connections.notConnected": "غير متصل",
  "connections.noEmail": "لم يتم توفير البريد الإلكتروني",
  "connections.emailVerified": "تم التحقق من Email",
  "connections.connected": "متصل",
  "connections.unavailable": "غير ممكّن",
  "connections.confirm": "هل تريد إزالة رابط {provider} من 30s.to؟ يظل تسجيل الدخول إلى Email متاحًا.",
  "connections.removed": "تمت إزالة رابط الهوية من 30s.to.",
  "connections.failed": "لا يمكن تحديث طرق تسجيل الدخول. حاول مرة أخرى لاحقًا.",
  "connections.help": "يؤدي هذا إلى إزالة تعيين هوية 30s.to فقط؛ ولا يلغي وصول الموفر. إدارة وصول الموفر:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "اتصالات Agent",
  "agentConnections.copy": "ثبّت Skill واحدة كي تجمع Agents التي تستخدمها المعلومات وتكتب النص وتحدّث مسودة 30s.to بأمان.",
  "agentConnections.addTitle": "توصيل Agent جديد",
  "agentConnections.addCopy": "عرض رابط الاتصال وخطوات الإعداد",
  "agentConnections.examplesDisclosure": "عرض أمثلة الاستخدام",
  "settings.title": "الإعدادات",
  "settings.copy": "إدارة الحساب والأمان والاتصالات الخارجية وخطة 30s.to.",
  "settings.navAria": "فئات الإعدادات",
  "settings.account.title": "الحساب",
  "settings.account.copy": "هويتك على 30s.to ومدخل ملفك الشخصي.",
  "settings.account.email": "البريد الإلكتروني للحساب",
  "settings.account.profile": "الملف الشخصي",
  "settings.account.plan": "الخطة الحالية",
  "settings.account.manageProfile": "إدارة الملف الشخصي",
  "settings.login.copy": "إدارة الهويات التي يمكنك استخدامها لتسجيل الدخول إلى 30s.to.",
  "settings.billing.copy": "راجع خطتك الحالية وحالة التجديد والوصول إلى الفوترة.",
  "settings.invites.copy": "إدارة رصيد دعوات Public Beta ورموز الدعوة الأخيرة.",
  "agentConnections.endpoint": "رابط الاتصال",
  "agentConnections.copyAction": "نسخ",
  "agentConnections.copied": "تم النسخ",
  "agentConnections.copyFailed": "تعذر النسخ. انسخ الرابط يدويًا.",
  "agentConnections.endpointCopied": "تم نسخ رابط الاتصال.",
  "agentConnections.stepsAria": "خطوات ربط Agent",
  "agentConnections.step1": "أضف خدمة بعيدة من إعدادات MCP أو الموصلات في Agent.",
  "agentConnections.step2": "الصق رابط الاتصال، ثم سجّل الدخول إلى 30s.to ووافق على الوصول.",
  "agentConnections.step3": "أخبر Agent بما تريد تغييره، ثم ارجع إلى 30s.to لمراجعة المسودة.",
  "agentConnections.examplesTitle": "جرّب أن تطلب",
  "agentConnections.exampleFirst": "اقرأ ملفي على 30s.to وقواعد التنسيق وساعدني على إكمال مقدمتي الأولى.",
  "agentConnections.exampleSection": "حافظ على أسلوبي وأعد كتابة قسم «الآن» فقط.",
  "agentConnections.exampleShorten": "اختصر المقدمة كاملة لتُقرأ في أقل من 30 ثانية. لا تنشرها.",
  "agentConnections.copyExample": "نسخ المثال {number}",
  "agentConnections.promptCopied": "تم نسخ مثال الطلب.",
  "agentConnections.boundary": "يمكن لـ Agents قراءة المسودات وتحديثها فقط. لا يمكنهم النشر أو إيقاف النشر نيابةً عنك.",
  "agentConnections.authorizedTitle": "الاتصالات المصرّح بها",
  "agentConnections.empty": "لم يتم تفويض أي Agent بعد.",
  "agentConnections.disabled": "اتصالات Agent غير مفعّلة بعد.",
  "agentConnections.scopeRead": "قراءة المسودة",
  "agentConnections.scopeWrite": "تحديث المسودة",
  "agentConnections.connectedAt": "تم الاتصال في {date}",
  "agentConnections.selfReported": "اسم العميل مقدّم من العميل نفسه",
  "agentConnections.revoke": "إلغاء",
  "agentConnections.confirm": "هل تريد إلغاء اتصال {client}؟ لن يتمكن بعد ذلك من الوصول إلى مسودة 30s.to الخاصة بك.",
  "agentConnections.confirmSkill": "هل تريد إلغاء اتصال 30s.to Skill؟ سيتم تسجيل خروج كل Agents المحلية التي تستخدم هذه Skill من 30s.to.",
  "agentConnections.revoked": "تم إلغاء اتصال Agent.",
  "agentConnections.failed": "تعذر تحديث اتصالات Agent. حاول لاحقًا.",
  "agentConnections.manualTitle": "ربط Remote MCP يدويًا",
  "agentConnections.manualCopy": "خيار متقدم: فوّض عميلًا يدعم Remote MCP بشكل منفصل",
  "skill.meta.title": "30s.to Skill — دع Agent يكتب نبذتك",
  "skill.meta.description": "شارك موقعك أو مشاريعك أو ملف أعمالك. يدرس Agent أعمالك ويجري معك مقابلة ليكتب نبذتك التي تُقرأ في 30 ثانية.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "تعريفك بنفسك،\nبمساعدة وكيلك.",
  "skill.copy": "أرسل إليه بعض الروابط. سيتعرّف عليك ويساعدك في كتابة تعريف بنفسك يُقرأ في 30 ثانية.",
  "skill.processTitle": "كيف يساعدك Agent في الكتابة",
  "skill.process.clues.title": "أرسل الروابط",
  "skill.process.clues.copy": "ملفك العام أو موقع مشروعك أو ملف أعمالك.",
  "skill.process.research.title": "بحث معمّق، ثم مقابلة",
  "skill.process.research.copy": "يدرس موقعك ومشاريعك وأعمالك بعمق، وينظّم أهم النقاط، ثم يجري معك مقابلة لاستكمال ما لا تذكره المواد.",
  "skill.process.profile.title": "يكتب Agent نبذتك",
  "skill.process.profile.copy": "تراجعان المحتوى والأسلوب معًا حتى تصبح النبذة معبّرة عنك.",
  "skill.installTitle": "ثبّتها في Agent",
  "skill.installCopy": "انسخ التعليمات، والصقها في وكيلك المعتاد، ثم أرسلها.",
  "skill.promptLabel": "تعليمة التثبيت",
  "skill.copyPrompt": "نسخ تعليمات التثبيت",
  "skill.promptCopied": "تم نسخ تعليمة التثبيت. الخطوة التالية: افتح Agent الذي تستخدمه، والصق التعليمة ثم أرسلها.",
  "skill.copyFailed": "تعذر النسخ. حدّد تعليمة التثبيت أدناه وانسخها يدويًا.",
  "skill.startTitle": "كيف تبدأ",
  "skill.start.install": "ثبّت مهارة 30s.to",
  "skill.start.chat": "ابدأ الحديث",
  "skill.start.chatCopy": "بعد التثبيت، افتح محادثة جديدة وقل:",
  "skill.start.prompt": "ساعدني في كتابة تعريف بنفسي باستخدام 30s.to.",
  "dashboard.kicker": "المقدمة الخاصة بي",
  "dashboard.defaultTitle": "مقدمة مدتها 30 ثانية",
  "dashboard.primaryEdit": "مواصلة التحرير",
  "dashboard.primaryCreate": "ابدأ في الإنشاء",
  "dashboard.unpublished": "لم يتم نشره",
  "dashboard.unselected": "لم يتم التحديد",
  "dashboard.confirmDiscard": "هل تريد تجاهل التغييرات غير المنشورة واستعادة الإصدار العام الحالي؟",
  "dashboard.discardFailed": "لا يمكن تجاهل التغييرات.",
  "dashboard.discardConflict": "تم تحديث هذه المسودة في مكان آخر. حدّث الصفحة وراجعها قبل المحاولة مرة أخرى.",
  "dashboard.discardNetworkFailed": "لا يمكن تجاهل التغييرات. حاول مرة أخرى لاحقًا.",
  "dashboard.discardDone": "تمت الاستعادة إلى الإصدار العام الحالي.",
  "dashboard.statusAria": "الوضع الحالي",
  "dashboard.versionAria": "علاقة الإصدار",
  "dashboard.publicPage": "صفحة عامة",
  "dashboard.indexingAllowed": "الفهرسة مسموحة",
  "dashboard.indexingBlocked": "متاح عبر الرابط",
  "dashboard.publicVersion": "النسخة المنشورة",
  "dashboard.invisible": "غير مرئية للآخرين بعد",
  "dashboard.draft": "مسودة",
  "dashboard.currentDraft": "النسخة الحالية القابلة للتحرير",
  "dashboard.draftSynced": "تمت المزامنة مع الصفحة العامة",
  "dashboard.editableVersionEmpty": "نسخة قابلة للتحرير · لم يتم إنشاؤها",
  "dashboard.editableVersionDirty": "نسخة قابلة للتحرير · لم يتم نشر التغييرات",
  "dashboard.editableVersionSynced": "نسخة قابلة للتحرير · يطابق الصفحة العامة",
  "dashboard.editableVersionUnpublished": "نسخة قابلة للتحرير · غير منشورة",
  "dashboard.betaActive": "نشيط",
  "dashboard.betaInactive": "غير نشط",
  "dashboard.adminCanPublish": "يمكن نشر حساب المشرف",
  "dashboard.betaAccessNote": "الوصول إلى النشر التجريبي العام",
  "dashboard.visibility": "نطاق الظهور",
  "dashboard.chooseOnPublish": "اختر أثناء تأكيد النشر",
  "dashboard.snapshot": "لقطة",
  "dashboard.snapshotAfterPublish": "يتم إنشاء لقطة الصفحة العامة بعد النشر",
  "dashboard.publishDetailsAria": "تفاصيل النشر",
  "dashboard.actionsAria": "إجراءات الإدارة",
  "dashboard.nextAction": "الخطوة التالية",
  "dashboard.openPublicPage": "فتح الصفحة العامة",
  "dashboard.changeVisibility": "تغيير طريقة النشر",
  "dashboard.unpublish": "إيقاف النشر",
  "dashboard.unpublishTitle": "هل تريد إيقاف النشر؟",
  "dashboard.unpublishDescription": "ستصبح الصفحة العامة غير متاحة فورًا. سنحتفظ بالمسودة والعنوان العام لتتمكن من النشر مرة أخرى.",
  "dashboard.unpublishWarning": "قد لا تختفي فورًا النسخ التي حفظتها محركات البحث أو أشخاص آخرون.",
  "dashboard.unpublishConfirm": "إيقاف النشر",
  "dashboard.unpublishBusy": "جارٍ الإيقاف...",
  "dashboard.unpublishSuccess": "لم تعد الصفحة العامة متاحة. تم الاحتفاظ بالمسودة والعنوان العام.",
  "dashboard.unpublishFailed": "تعذر إيقاف النشر. حاول مرة أخرى لاحقًا.",
  "dashboard.discardBusy": "جارٍ الاستعادة...",
  "dashboard.discard": "تجاهل التغييرات",
  "dashboard.metricsAria": "بيانات خفيفة الوزن",
  "dashboard.views": "وجهات النظر",
  "dashboard.clicks": "النقرات",
  "dashboard.readingTime": "وقت القراءة",
  "dashboard.theme": "سمة",
  "dashboard.noTheme": "لم يتم التحديد",
  "dashboard.visibility.indexed": "السماح بالفهرسة في محركات البحث",
  "dashboard.visibility.unlisted": "متاح عبر الرابط",
  "dashboard.visibility.indexedNote": "قد تظهر في نتائج البحث",
  "dashboard.visibility.unlistedNote": "تبقى مرئية لأي شخص لديه الرابط المباشر",
  "dashboard.snapshot.ready": "ذاكرة التخزين المؤقت جاهزة",
  "dashboard.snapshot.failed": "التراجع D1",
  "dashboard.snapshot.none": "لم يتم إنشاؤها",
  "dashboard.snapshot.readyNote": "لقطة عامة مكتوبة على KV",
  "dashboard.snapshot.failedNote": "لا تزال الصفحة العامة تعمل من خلال خيار D1 الاحتياطي",
  "dashboard.snapshot.noneNote": "لا توجد لقطة متاحة للنسخة المنشورة الحالية",
  "invite.title": "قم بدعوة الأصدقاء إلى النسخة التجريبية العامة",
  "invite.remaining": "دعوات {remaining} / {quota} غادرت هذا الشهر.",
  "invite.generateFailed": "تعذر إنشاء الدعوة.",
  "invite.generated": "تم إنشاء {count} من رموز الدعوة. تظهر هذه المرة فقط.",
  "invite.quotaUsed": "تم استخدام حصة الدعوة الشهرية.",
  "invite.generating": "جارٍ الإنشاء...",
  "invite.generate": "إنشاء الرموز المتبقية ({count}) دفعة واحدة",
  "invite.batchTitle": "رموز الدعوة التي أُنشئت الآن: {count}",
  "invite.copyAll": "نسخ جميع الرموز",
  "invite.copiedAll": "تم نسخ جميع الرموز",
  "invite.copyMessage": "نسخ نص المشاركة",
  "invite.messageCopied": "تم نسخ نص المشاركة",
  "invite.share": "مشاركة مباشرة",
  "invite.shared": "تم فتح لوحة المشاركة.",
  "invite.shareFallback": "المشاركة المباشرة غير متاحة، لذا تم نسخ النص.",
  "invite.shareFailed": "تعذرت المشاركة. انسخ نص المشاركة بدلاً من ذلك.",
  "invite.shareMessage": "أستخدم 30s.to لإنشاء تعريف شخصي في 30 ثانية، وأدعوك لتجربته.\n\nرموز الدعوة:\n{codes}\n\nافتح {url} للبدء.",
  "invite.recentAria": "حالة استخدام رموز الدعوة",
  "invite.statusTitle": "حالة الاستخدام",
  "invite.statusSummary": "{active} متاح · {redeemed} مستخدم · {expired} منتهي · {revoked} ملغى",
  "invite.status.revoked": "تم إبطاله",
  "invite.status.redeemed": "مستخدم",
  "invite.status.expired": "منتهي الصلاحية",
  "invite.status.active": "متاح",
  "invite.copy": "ينسخ",
  "invite.copied": "منقول",
  "invite.showOnce": "تظهر مرة واحدة فقط",
  "invite.expiryUnknown": "انتهاء الصلاحية غير معروف",
  "invite.expiresAt": "تنتهي صلاحيته في {date}",
  "management.handlePending.title": "تغيير العنوان معلق",
  "management.handlePending.description": "العنوان العام الحالي لا يزال {publishedAddress}. النشر ينشط {draftAddress}.",
  "management.handlePending.next": "قم بنشر التغييرات قبل أن يصبح {draftAddress} هو العنوان العام.",
  "management.dirty.title": "تغييرات غير منشورة",
  "management.dirty.description": "لم يتم نشر مسودتك على الصفحة العامة.",
  "management.dirty.next": "نشر التغييرات لمزامنة الصفحة العامة مع هذه المسودة.",
  "management.published.title": "تم النشر",
  "management.published.description": "الصفحة العامة محدثة.",
  "management.published.next": "تتم مزامنة الصفحة العامة. استمر في التحرير عندما تريد تعديله.",
  "management.unpublished.title": "غير منشورة",
  "management.unpublished.description": "لا تزال هذه المقدمة محفوظة كمسودة فقط.",
  "management.unpublished.next": "قم بنشره قبل أن يتمكن الآخرون من زيارة العنوان العام.",
  "management.empty.title": "لا يوجد مقدمة حتى الآن",
  "management.empty.description": "اختر عنوانًا واكتب مقدمة مدتها 30 ثانية.",
  "management.empty.next": "قم بإنشاء مسودة أولاً. تبقى الشيكات قبل النشر في المحرر.",
  "management.publish.create": "نشر المقدمة",
  "management.publish.update": "نشر التغييرات",
  "abuse.kicker": "الثقة والسلامة",
  "abuse.title": "صفحة التقرير",
  "abuse.copy": "تُستخدم التقارير فقط لمراجعة السلامة. هويتك ليست عامة.",
  "abuse.missingHandle": "هدف التقرير مفقود.",
  "abuse.done": "تم استلام التقرير. سوف نقوم بمراجعته قريبا.",
  "abuse.failed": "فشل التقديم. حاول مرة أخرى لاحقًا.",
  "abuse.reason.spam": "رسائل إلكترونية مزعجة",
  "abuse.reason.impersonation": "التمثيل",
  "abuse.reason.abuse": "التحرش أو الكراهية",
  "abuse.reason.illegal": "محتوى غير قانوني",
  "abuse.reason.other": "مسألة أخرى",
  "abuse.submitBusy": "جارٍ الإرسال…",
  "abuse.submit": "إرسال التقرير",
  "terms.title": "شروط الخدمة",
  "privacy.title": "إشعار الخصوصية",
  "validation.handle.required": "أدخل معرّف العنوان.",
  "validation.handle.invalid": "يجب أن يتكون المعرّف من 4 إلى 24 حرفًا إنجليزيًا صغيرًا.",
  "validation.handle.reserved": "هذا العنوان العام غير متاح. جرّب عنوانًا آخر.",
  "validation.handle.unavailable": "هذا العنوان العام غير متاح. جرّب عنوانًا آخر.",
  "validation.handle.frozen": "هذا العنوان العام غير متاح. جرّب عنوانًا آخر.",
  "validation.handle.protected": "هذا العنوان العام غير متاح. جرّب عنوانًا آخر.",
  "validation.handle.checkFailed": "لم نتمكن من تأكيد هذا العنوان.",
  "validation.handle.changeLimit": "يمكنك تغيير عنوانك العام مرة واحدة فقط كل 30 يومًا.",
  "validation.displayName.required": "الاسم أو اللقب مطلوب.",
  "validation.identity.required": "مطلوب هوية سطر واحد.",
  "validation.tags.range": "أضف 1-5 علامات.",
  "validation.links.limit": "يمكنك إضافة ما يصل إلى {limit} روابط مستقلة.",
  "validation.links.empty": "لا توجد روابط حتى الآن. يمكنك إضافة ملف تعريف اجتماعي أو صفحة حجز أو طريقة اتصال.",
  "validation.input.tooLong": "يمكن أن يصل النص إلى {limit} حرفًا.",
  "validation.body.placeholder": "لا يزال النص يحتوي على {detail}. استبدله بمحتوى حقيقي أو احذفه.",
  "validation.body.oldTemplate": "قالب النص السابق",
  "validation.body.readingTime": "وقت القراءة المقدر {seconds} ثانية. اختصر النص إلى {maximum} ثانية كحد أقصى.",
  "validation.body.readingTimeLong": "وقت القراءة المقدر {seconds} ثانية، وهو أطول من المدة المقترحة البالغة {recommended} ثانية، ولكن لا يزال بإمكانك النشر.",
  "validation.body.readingTimeShort": "وقت القراءة المقدر {seconds} ثانية. أضف محتوى حتى يصل إلى {minimum} ثانية على الأقل.",
  "validation.markdown.h1": "# العناوين على مستوى الصفحة غير مدعومة",
  "validation.markdown.deepHeading": "### والعناوين الأعمق غير مدعومة",
  "validation.markdown.image": "بناء جملة الصورة غير مدعوم",
  "validation.markdown.codeBlock": "كتل التعليمات البرمجية غير مدعومة",
  "validation.markdown.taskList": "قوائم المهام غير مدعومة",
  "validation.markdown.table": "الجداول غير مدعومة",
  "validation.markdown.footnote": "الحواشي السفلية غير مدعومة",
  "validation.markdown.html": "HTML والتضمينات غير مدعومة",
  "validation.markdown.commentUnclosed": "تعليق النص يفتقد علامة الإغلاق -->",
  "validation.markdown.commentStrayClose": "تعليق النص يفتقد علامة الفتح <!--",
  "validation.markdown.commentNested": "تعليقات <!-- --> المتداخلة غير مدعومة",
  "validation.markdown.nestedHeading": "يجب أن تكون عناوين الأقسام في المستوى الجذري للمستند",
  "validation.markdown.setextHeading": "عناوين Setext غير مدعومة",
  "validation.markdown.headingInline": "لا يمكن أن تحتوي عناوين الأقسام إلا على نص عادي",
  "validation.markdown.frontmatter": "frontmatter غير مدعوم",
  "validation.markdown.indentedCode": "كتل التعليمات البرمجية المزاحة غير مدعومة؛ استخدم كتلة مسيجة",
  "validation.markdown.codeFenceUnclosed": "علامة إغلاق كتلة التعليمات البرمجية مفقودة",
  "validation.markdown.codeLanguage": "تسمح علامة اللغة بـ 1–32 حرفًا أو رقمًا أو _ أو + أو -",
  "validation.markdown.listDepth": "تدعم القوائم حتى ثلاثة مستويات",
  "validation.markdown.tableSize": "تدعم الجداول حتى 6 أعمدة و20 صفًا",
  "validation.markdown.linkProtocol": "تدعم روابط النص HTTPS والبريد الإلكتروني فقط",
  "validation.link.unsupportedType": "هذا النوع من الروابط غير مدعوم بعد. اختر رابط موقع إلكتروني أو منصة أو حجز.",
  "validation.link.labelRequired": "لا يمكن أن يكون اسم الرابط فارغًا.",
  "validation.link.providerRequired": "اختر منصة الحجز.",
  "validation.link.valueRequired": "لا يمكن أن يكون {label} فارغًا.",
  "validation.link.httpsOnly": "الروابط تدعم https://. فقط",
  "validation.link.invalid": "أدخل رابطًا صالحًا.",
  "validation.link.validEmail": "أدخل بريدًا إلكترونيًا صالحًا.",
  "validation.link.validGithub": "أدخل مقبض GitHub صالحًا.",
  "validation.link.validBilibili": "أدخل Bilibili UID صالحًا.",
  "validation.link.validXiaohongshu": "أدخل رابطًا صالحًا لملف تعريف Xiaohongshu.",
  "validation.link.validGoogleCalendar": "أدخل رابط حجز Google Calendar صالحًا.",
  "validation.link.validMicrosoftBookings": "أدخل رابط Microsoft Bookings صالح.",
  "validation.theme.proRequired": "يتطلب نشر هذا الموضوع 30s Pro.",
  "validation.link.validHubSpot": "أدخل رابط HubSpot Meetings صالح.",
  "validation.account.banned": "لا يمكن لهذا الحساب النشر الآن.",
  "validation.account.login": "الرجاء تسجيل الدخول أولا.",
  "validation.account.invite": "قم بتنشيط حسابك باستخدام رمز الدعوة أولاً.",
  "validation.publish.failed": "فشل النشر. حاول مرة أخرى لاحقًا.",
  "validation.turnstile.required": "أكمل فحص الأمان.",
  "validation.report.missing": "لم تُحدد الصفحة المراد الإبلاغ عنها.",
  "validation.report.reason": "اختر سبب الإبلاغ.",
  "validation.report.notReportable": "لا يمكن الإبلاغ عن هذه الصفحة الآن.",
  "common.listSeparator": ",",
  "dashboard.section.status": "الحالة",
  "dashboard.section.performance": "الأداء",
  "dashboard.fullAnalytics": "عرض التحليلات الكاملة",
  "dashboard.shareCard": "مشاركة البطاقة",
  "dashboard.timestamp.notPublished": "لم يتم نشره",
  "dashboard.timestamp.notEdited": "لم يتم تحريره",
  "dashboard.timestamp.published": "تم النشر {date} بالتوقيت العالمي المنسق",
  "dashboard.timestamp.edited": "تم تحرير {date} بالتوقيت العالمي المنسق",
  "upgrade.publishTheme": "نشر {theme}",
  "upgrade.copy": "تم حفظ اختيارك ويمكنك متابعة معاينته بالكامل. بعد الترقية يمكنك النشر دون إعادة التحرير.",
  "upgrade.benefit.themes": "نشر كل سمة متميزة",
  "upgrade.benefit.analytics": "انظر وقت القراءة والانتهاء",
  "upgrade.benefit.cards": "تمت مزامنة بطاقات السمات مع OG الاجتماعي",
  "upgrade.seePro": "شاهد 30s Pro",
  "upgrade.keepEditing": "استمر في التحرير",
  "pro.meta.title": "30s Pro — عبر عن نفسك",
  "pro.meta.description": "قوالب مميزة وتحليلات للقراءة وبطاقات مشاركة تجعل نبذتك ذات الثلاثين ثانية أقرب إليك.",
  "pro.title": "عبّر عن نفسك بوضوح.",
  "pro.intro": "تبقى القراءة في 30 ثانية. يمنحك Pro مساحة أوسع للتعبير، وقراءة أوضح للتفاعل، ومواد جاهزة للمشاركة.",
  "pro.priceAction": "عرض Founding Price",
  "pro.summaryAria": "ملخص مزايا Pro",
  "pro.summaryThemes": "قوالب مميزة",
  "pro.summaryAnalytics": "يومًا من التحليلات",
  "pro.summaryShare": "متزامنة مع بطاقة المشاركة",
  "pro.benefitsKicker": "أدوات Pro",
  "pro.benefitsTitle": "من التعبير إلى الوصول.",
  "pro.benefit.themes.title": "قوالب مميزة",
  "pro.benefit.themes.body": "ثمانية قوالب، في مقدمتها Terminal. عاينها كلها مجانًا، وانشر اختيارك مع Pro.",
  "pro.benefit.analytics.title": "جودة القراءة",
  "pro.benefit.analytics.body": "تجاوز عدد الزيارات إلى وقت القراءة الفعلي ونسبة الإكمال ومدى التقدم واتجاهات 30 و90 و365 يومًا ونسبة النقر على الروابط.",
  "pro.benefit.share.title": "شارك بطريقتك",
  "pro.benefit.share.body": "يحتوي البرنامج المجاني على بطاقة اسم ورابط واحدة بسيطة. يضيف Pro بطاقتين عالميتين وتصميمًا واحدًا لكل سمة. يصبح اختيارك هو صورة OG، مع QR مدمج للمشاركة والتنزيل.",
  "pro.benefit.attribution.title": "أنت في الواجهة",
  "pro.benefit.attribution.body": "أخفِ اسم 30s.to داخل القالب مع بقاء وظائف الإبلاغ واختيار اللغة الضرورية.",
  "pro.pricingTitle": "كلما انضممت أبكر، بقي الأمر أبسط.",
  "pro.pricingBody": "يبقى Founding Price ما دام اشتراكك مستمرًا. إذا عدت بعد انتهائه، يطبق السعر الساري حينها.",
  "pro.terminalAria": "معاينة موضوع Terminal Pro",
  "pro.checkout.continuous": "يبقى السعر ما دام الاشتراك مستمرًا",
  "pro.checkout.intervalAria": "الفاصل الزمني للفوترة",
  "pro.checkout.monthly": "شهري",
  "pro.checkout.yearly": "سنوي",
  "pro.checkout.save": "وفر 16 دولارًا",
  "pro.checkout.periodYear": "سنة",
  "pro.checkout.periodMonth": "شهر",
  "pro.checkout.annualNote": "ما يعادل ${price} شهريًا، أقل بنسبة 44% من الخطة الشهرية.",
  "pro.checkout.monthlyNote": "ادفع شهريًا وألغِ في نهاية أي دورة متى شئت.",
  "pro.checkout.includeThemes": "جميع القوالب المميزة",
  "pro.checkout.includeAnalytics": "جودة القراءة والتحليلات لمدة 365 يوما",
  "pro.checkout.includeCards": "بطاقات السمات وQR وOG",
  "pro.checkout.includeAttribution": "إخفاء اسم 30s.to داخل القالب",
  "pro.checkout.manage": "إدارة اشتراك Pro",
  "pro.checkout.comingSoon": "الدفع متاح قريبًا",
  "pro.checkout.signIn": "سجّل الدخول للترقية",
  "pro.checkout.inviteRequired": "تحتاج إلى دعوة Beta",
  "pro.checkout.opening": "جارٍ فتح الدفع الآمن…",
  "pro.checkout.upgrade": "الترقية إلى 30s Pro",
  "pro.checkout.footnote": "دفع آمن عبر Creem. تظهر الضرائب قبل الدفع؛ لا توجد فترة تجريبية ويتجدد الاشتراك تلقائيًا.",
  "pro.checkout.unavailable": "يتعذر فتح الدفع الآن. حاول لاحقًا.",
  "pro.checkout.networkError": "تعذر الاتصال. حاول مرة أخرى لاحقًا.",
  "billing.panelAria": "Pro والفوترة",
  "billing.plan": "الباقة",
  "billing.status.canceling": "الإلغاء مجدول",
  "billing.status.pastDue": "دفعة متأخرة",
  "billing.status.active": "نشط",
  "billing.status.free": "مجاني",
  "billing.yearly": "سنويا",
  "billing.monthly": "شهريا",
  "billing.basicPlan": "الخطة الأساسية",
  "billing.ends": "ينتهي {date}",
  "billing.renews": "يجدد {date}",
  "billing.graceEnds": "تنتهي فترة السماح: {date}",
  "billing.anomaly": "تحتاج حالة الفواتير الخاصة بك إلى مراجعة يدوية. تواصل مع support@30s.to.",
  "billing.opening": "جارٍ فتح إدارة الفوترة",
  "billing.manage": "إدارة الفوترة",
  "billing.upgrade": "الترقية إلى Pro",
  "billing.openingHistory": "جارٍ فتح سجل الفواتير…",
  "billing.viewHistory": "عرض تاريخ الفواتير",
  "billing.portalUnavailable": "إدارة الفواتير غير متاحة مؤقتًا.",
  "billing.networkError": "فشل الاتصال بالشبكة. يرجى المحاولة مرة أخرى.",
  "billingReturn.kicker": "30s Pro · التحقق من الدفع",
  "billingReturn.activeTitle": "تم تفعيل Pro",
  "billingReturn.failedTitle": "لم يتم تأكيد الدفع بعد",
  "billingReturn.waitingTitle": "تأكيد الدفع الخاص بك",
  "billingReturn.failedCopy": "ربما لا تزال مزامنة دفعتك جارية. تحقق من لوحة المعلومات مرة أخرى لاحقًا؛ لا يتم منح الوصول أبدًا من صفحة العودة وحدها.",
  "billingReturn.waitingCopy": "نحن نتحقق من اشتراكك مع مزود الدفع. أبقِ هذه الصفحة مفتوحة.",
  "billingReturn.back": "العودة إلى لوحة التحكم",
  "analytics.kicker": "30s Pro · التحليلات",
  "analytics.nav": "التحليلات",
  "analytics.title": "من الزيارة إلى إكمال القراءة.",
  "analytics.copy": "تابع الرحلة من الزيارة إلى إكمال القراءة والنقر على الروابط، من دون تتبع الأشخاص. تعتمد التواريخ وإزالة التكرار على توقيت UTC.",
  "analytics.rangeAria": "النطاق الزمني",
  "analytics.days": "{count} أيام",
  "analytics.uniqueVisitors": "الزوار الفريدون",
  "analytics.rangeTotal": "إجمالي آخر {count} يومًا",
  "analytics.averageReading": "متوسط وقت القراءة الفعلي",
  "analytics.activeReadingNote": "الوقت الذي كانت فيه الصفحة ظاهرة ونشطة",
  "analytics.completionRate": "معدل الإنجاز",
  "analytics.completedVisitors": "أكمل {count} من الزوار القراءة",
  "analytics.overallCtr": "إجمالي نسبة النقر إلى الظهور",
  "analytics.engagedVisitors": "تفاعل {count} من الزوار",
  "analytics.trafficTrend": "اتجاه حركة المرور",
  "analytics.dailyTrendAria": "اتجاه الزوار الفريدين يوميًا",
  "analytics.readingCompletion": "إكمال القراءة",
  "analytics.dailyMaximum": "الزوار / الحد الأقصى اليومي",
  "analytics.visitorCount": "{count} الزوار",
  "analytics.topLinks": "أعلى الروابط",
  "analytics.uniqueClickers": "الأشخاص الذين نقروا",
  "analytics.linkTrendAria": "الاتجاه اليومي لـ {label}",
  "analytics.noInteractions": "لا توجد تفاعلات مع الروابط حتى الآن.",
  "analytics.audienceOverview": "نظرة عامة على الجمهور",
  "analytics.pageLevel": "مستوى الصفحة",
  "analytics.referrers": "مصادر الزيارات",
  "analytics.devices": "الأجهزة",
  "analytics.countries": "البلدان",
  "analytics.noData": "لا توجد بيانات حتى الآن",
  "analytics.durationSeconds": "{seconds} ث",
  "analytics.durationMinutes": "{minutes} د {seconds} ث",
  "share.card": "بطاقة المشاركة",
  "share.variant.classic": "كلاسيكي",
  "share.variant.classicNote": "هادئ",
  "share.variant.contact": "الفهرس",
  "share.variant.contactNote": "منظم",
  "share.variant.theme": "طبعة {theme}",
  "share.variant.themeNote": "الموضوع",
  "share.variant.universal": "عالمي",
  "share.saveFailed": "لا يمكن الحفظ",
  "share.styleUpdated": "تم تحديث النمط",
  "share.networkError": "فشل الاتصال بالشبكة",
  "share.linkCopied": "تم نسخ الرابط",
  "share.copyFailed": "فشل النسخ",
  "share.text": "مقدمة مدتها 30 ثانية",
  "share.failed": "لا يمكن المشاركة",
  "share.published": "تم النشر",
  "share.draft": "مسودة",
  "share.style": "النمط",
  "share.alt": "بطاقة مشاركة {name}",
  "share.publishFirst": "انشر للمشاركة",
  "share.action": "شارك",
  "share.download": "تحميل",
  "share.openPublicPage": "فتح الصفحة العامة",
  "share.chooseStyle": "اختر نمط البطاقة",
  "share.close": "إغلاق",
  "share.cardStyle": "نمط البطاقة",
  "share.chooseOne": "اختر النمط",
  "share.chooseStyleAria": "اختر نمط بطاقة المشاركة",
  "share.saving": "جارٍ الحفظ",
  "validation.body.placeholderDetail.legacyTemplate": "قالب النص القديم",
  "validation.body.placeholderDetail.ellipsis": "العنصر النائب `...`",
  "validation.body.placeholderDetail.sampleLink": "رابط العينة `https://example.com`",
  "validation.body.placeholderDetail.projectName": "العنصر النائب `项目名`",
  "validation.body.placeholderDetail.instruction": "نص تعليمات القالب",
  "analytics.gate.signInTitle": "سجّل الدخول لعرض التحليلات",
  "analytics.gate.signInCopy": "تظل بيانات الزيارات والتفاعل محفوظة بأمان داخل لوحة التحكم.",
  "analytics.gate.signInAction": "تسجيل الدخول",
  "analytics.gate.proTitle": "اعرف ما إذا كان الزوار يقرؤون تعريفك حتى النهاية.",
  "analytics.gate.proCopy": "اطّلع على وقت القراءة الفعلي ومعدل إكمال القراءة وتوزيع التقدم واتجاهات 30 و90 و365 يومًا ونسبة النقر إلى الظهور للروابط.",
  "analytics.gate.proAction": "استكشاف 30s Pro",
  "analytics.gate.emptyTitle": "تبدأ بياناتك بالظهور بعد النشر.",
  "analytics.gate.emptyCopy": "أكمل تعريفك الذي يستغرق 30 ثانية أولًا. بعد النشر ستظهر اتجاهات الزيارات والتفاعل.",
  "analytics.gate.emptyAction": "بدء الإنشاء",
  "analytics.gate.privacyNote": "تجميع يومي بتوقيت UTC · إزالة تكرار مجهولة الهوية · لا نحتفظ بعنوان IP الأصلي",
  "handleEdit.previous": "العناوين السابقة المحمية",
  "handleEdit.deadlines": "ينتهي التوجيه في {redirectDate}؛ وتنتهي الحماية في {releaseDate}.",
  "handleEdit.usePrevious": "استخدام هذا العنوان",
  "handleEdit.reclaimAvailable": "يمكنك استعادة هذا العنوان السابق.",
  "publish.handleReclaimed": "تُعد الاستعادة تغييرًا للعنوان. سيبدأ للعنوان الحالي توجيه جديد لمدة 30 يومًا وحماية لمدة 180 يومًا."
}
